/**
 * The CSRF token, held in memory.
 *
 * A leaf module on purpose: it imports nothing. Putting this in `Api.ts` meant
 * the auth slice had to import Api to store the token, Api imports the Redux
 * store, and the store imports the auth slice — a three-module cycle whose
 * outcome depended on which one the bundler happened to evaluate first. Reach
 * the slice before the store and `configureStore` receives an `undefined`
 * reducer and throws at boot. Nothing imports this file's dependencies because
 * it has none, so the cycle cannot form.
 *
 * It cannot come from a cookie. The portal is served from eduact.me and the API
 * from api.eduact.me, so any cookie the API sets is host-only to the API's host
 * and invisible to this code.
 *
 * Memory rather than localStorage: it defends against forged cross-origin
 * requests, and storage would hand it to exactly the XSS that the httpOnly
 * session cookie is out of reach of.
 */
let csrfToken: string | null = null

export const setCsrfToken = (token: string | null | undefined): void => {
	if (token) csrfToken = token
}

export const clearCsrfToken = (): void => {
	csrfToken = null
}

export const readCsrfToken = (): string | null => csrfToken
